import { $enum } from "ts-enum-util";
import { PartyPosition } from "./autogen/PartyPosition";
import { GovernmentBillStage } from "./autogen/GovernmentBillStage";

//Why does this module exist? Why this stupid song and dance? Because TypeScript 
//lacks a simple construct that lets us exhaustively fill out an array of all possible 
//values for a given enum value, and while ts-enum-util gives us said array, it gives it 
//to us in a completely undesirable order!
//
//So what if we add a new enum value here in the future? Too bad, have to add it
//manually!

export function getBillStages(): [GovernmentBillStage, string][] {
    const e = $enum(GovernmentBillStage);
    const all = e.getValues();
    const sorted: [GovernmentBillStage, string][] = [];

    let v = all.filter(val => val == GovernmentBillStage.First)[0];
    if (v != null)
        sorted.push([v, "First Reading"]);
    v = all.filter(val => val == GovernmentBillStage.Second)[0];
    if (v != null)
        sorted.push([v, "Second Reading"]);
    v = all.filter(val => val == GovernmentBillStage.Committee)[0];
    if (v != null)
        sorted.push([v, "Committee Stage"]);
    v = all.filter(val => val == GovernmentBillStage.Third)[0];
    if (v != null)
        sorted.push([v, "Third Reading"]);

    return sorted;
}

export function getPartyPositions(): [PartyPosition, string][] {
    const e = $enum(PartyPosition);
    const all = e.getValues();
    const sorted: [PartyPosition, string][] = [];

    let v = all.filter(val => val == PartyPosition.Support)[0];
    if (v != null)
        sorted.push([v, "Support"]);
    v = all.filter(val => val == PartyPosition.Oppose)[0];
    if (v != null)
        sorted.push([v, "Oppose"]);
    v = all.filter(val => val == PartyPosition.SupportToSelectCommittee)[0];
    if (v != null)
        sorted.push([v, "Support to Select Committee"]);
    v = all.filter(val => val == PartyPosition.ConscienceVote)[0];
    if (v != null)
        sorted.push([v, "Conscience"]);

    return sorted;
}


// WEBPACK FOOTER //
// ./src/model/enum-display.ts